module.exports = __webpack_public_path__ + "img/4.02.thmb.xs.e8e1cc62.jpg";